<template>
	<div>
    <b-modal ref="badWordConfirmModal" hide-header no-close-on-backdrop no-close-on-esc centered>
      <div class="text-center">
        <h6>We noticed that there is some unwanted language in your message. Would you still like to send the message?.</h6>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-button @click="sendMaskedBadWords" class="btn button-primary next float-right mr-2">Yes, Continue</b-button>
        <b-button @click="editProfaneMessage" class="btn button-primary next float-right mr-2">Edit</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Filter from 'bad-words'
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'bad-words-prompt',
    props: ['editorInstanceId'],
    data: () => {
      return {
        customFilter: new Filter({placeHolder: 'x'})
      }
    },
    computed: {
      ...mapState({
        'customBadWords': state => state.dashboard.customBadWords
      })
    },
    async mounted () {
      await this.loadAllBadWords()
      await this.addCustomBadWords()
    },
    methods: {
      ...mapActions([
        'loadAllBadWords'
      ]),
      showPrompt (message, isBadWordsNotAllowed) {
        let isProfane = this.customFilter.isProfane(message)
        let isShowPrompt = isProfane && isBadWordsNotAllowed
        if (isShowPrompt) {
          this.$refs.badWordConfirmModal.doShow()
        }
        return isShowPrompt
      },
      hidePrompt () {
        this.$refs.badWordConfirmModal.hide()
      },
      editProfaneMessage () {
        this.hidePrompt()
        if (this.editorInstanceId) {
          let elemId = '#' + this.editorInstanceId
          $(elemId)[0].contentWindow.document.body.focus()
        }
      },      
      sendMaskedBadWords () {
        this.$emit('sendMaskedBadWords')
        this.hidePrompt()
      },
      addCustomBadWords () {
        this.customFilter.addWords(...this.customBadWords)
      },
      maskBadWords (message) {
        if (message.indexOf('<img') !== -1) {
          return message
        }
        return this.customFilter.clean(message)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/dashboard/components/BadWordsPrompt.vue